module.exports = __webpack_public_path__ + "img/tpay-orange-ar.81c60169.png";